
import { Component, Vue } from "vue-property-decorator"
import { DimssaButton, ButtonState } from "@/components/dimssa-button.vue"
import { datasetsExists, getDatasetExists, getDatasetTableExists, isDatasetTableSchemaUpdated } from "@/helpers/graphql"

@Component({
  components: {
    DimssaButton,
  },
})
export default class BigQueryDatasets extends Vue {
  gotTableIds: boolean = false
  tableNames: string[] = []
  selectedTableNames: string[] = []
  datasetIds: string[] = []
  selectedDatasetId: string | null = null
  message: string = "Fetching dataset and table names."
  datasetTableIds: { datasetId: string; tables: { name: string }[] }[] = []
  expandedDatasets: any[] = []
  updateKey: number = 0
  updateInnerTableKey: number = 0
  //updateKeyTableExists: number = 0;

  datasetExistsButtonStates: { [datasetId: string]: ButtonState } = {}
  datasetTableExistsButtonStates: { [datasetId: string]: { [tableId: string]: ButtonState } } = {}

  lookForProblemsButtonState: ButtonState = "ready"
  fixProblemsButtonState: ButtonState = "disabled"
  lookForProblemsCheckedCount: number = 0
  lookForProblemsTotalCount: number = 0

  get lookForProblemsButtonLabel(): string {
    if (!this.lookForProblemsTotalCount) return "Look for problems"
    const percent = Math.round((this.lookForProblemsCheckedCount / this.lookForProblemsTotalCount) * 100)
    return `Look for problems (${this.lookForProblemsCheckedCount}/${this.lookForProblemsTotalCount} - ${percent}%)`
  }

  async mounted() {
    //console.log("querying allDatasetTables...");
    // let gql = `query allDatasetTables {
    //   allDatasetTables {
    //     dataset
    //     tables {
    //       name
    //       tableSchema {
    //         ...schema
    //       }
    //       latestSchema {
    //         ...schema
    //       }
    //     }
    //   }
    // } fragment schema on Schema {
    //   ${this.gqlSchemaFragmentHelper(10)}
    // }
    // fragment schemaFields on SchemaField {
    //   name
    //   type
    //   mode
    // }`;
    await this.getDatasetTableIds()
  }

  async getDatasetTableIds() {
    let gql = `query allDatasetTableIds {
      allDatasetTableIds {
        dataset
        tables {
          name
        }
      }
    }`

    try {
      console.log(gql)
      let json = await this.$store.dispatch("graphQl", {
        gql,
      })
      //console.log(JSON.stringify(json));
      console.dir(json)
      if (!json.data.allDatasetTableIds) throw Error("No data.allDatasetTableIds")
      this.datasetTableIds = []
      this.datasetIds = []
      this.tableNames = []
      const tableNames: Set<string> = new Set()
      for (const d of json.data.allDatasetTableIds) {
        this.datasetExistsButtonStates[d.dataset] = "ready"
        //this.clickDatasetExists(d.dataset);
        this.datasetTableIds.push({
          datasetId: d.dataset,
          tables: d.tables.map((t: any) => {
            if (!this.datasetTableExistsButtonStates[d.dataset]) this.datasetTableExistsButtonStates[d.dataset] = {}
            this.datasetTableExistsButtonStates[d.dataset][t.name] = "ready"
            return { name: t.name }
          }),
        })
        this.datasetIds.push(d.dataset)
        for (const t of d.tables) {
          tableNames.add(t.name)
        }
      }
      for (const t1 of tableNames) {
        this.tableNames.push(t1)
      }
      this.gotTableIds = true
    } catch (err) {
      console.log(err)
      this.message = `Error: ${err}`
    }
  }

  gqlSchemaFragmentHelper(depth: number): string {
    if (depth <= 0) return "fields { ...schemaFields }"
    return `fields { ...schemaFields ${this.gqlSchemaFragmentHelper(depth - 1)} }`
  }

  viewTable(datasetId: string, tableId: string) {
    // console.log(`datasetId: ${datasetId}`);
    // console.log(`tableId: ${tableId}`);
    // console.log(JSON.stringify(datasetId));
    this.$router.push({ name: "bigquery-table", params: { datasetId, tableId } })
  }

  async clickDatasetExists(datasetId: string) {
    this.datasetExistsButtonStates[datasetId] = "busy"
    this.updateKey++
    try {
      const datasetExists = await getDatasetExists(datasetId)
      if (datasetExists) this.datasetExistsButtonStates[datasetId] = "success"
      else this.datasetExistsButtonStates[datasetId] = "error"
    } catch (err) {
      console.error(err)
      this.datasetExistsButtonStates[datasetId] = "error"
    }
    this.updateKey++
  }

  async clickDatasetTableCheck(datasetId: string, tableId: string) {
    this.datasetTableExistsButtonStates[datasetId][tableId] = "busy"
    this.updateInnerTableKey++
    let tableExists
    try {
      tableExists = await getDatasetTableExists(datasetId, tableId)
      if (!tableExists) this.datasetTableExistsButtonStates[datasetId][tableId] = "error"
      else {
        const schemaUpdated = await isDatasetTableSchemaUpdated(datasetId, tableId)
        if (schemaUpdated) this.datasetTableExistsButtonStates[datasetId][tableId] = "success"
        else this.datasetTableExistsButtonStates[datasetId][tableId] = "error"
      }
    } catch (err) {
      console.error(err)
      this.datasetTableExistsButtonStates[datasetId][tableId] = "error"
    }
    this.updateInnerTableKey++
  }

  problemItems: any = []
  async lookForProblems() {
    try {
      this.problemItems = []
      this.lookForProblemsButtonState = "busy"
      this.lookForProblemsCheckedCount = 0
      this.lookForProblemsTotalCount = 0

      //Look for datasets that do not exists
      const datasetIds = this.datasetTableIds.map((dt) => dt.datasetId)
      const datasetIdsToCheck = this.selectedDatasetId ? datasetIds.filter((di) => di === this.selectedDatasetId) : datasetIds
      const existingDatasetIds: string[] = datasetIdsToCheck.length ? await datasetsExists(datasetIdsToCheck) : []
      const nonExistingDatasetIds = datasetIdsToCheck.filter((di) => !existingDatasetIds.find((edi) => edi === di))
      this.problemItems.push(...nonExistingDatasetIds.map((nedi) => ({ type: "non-existing-dataset", datasetId: nedi, buttonState: "ready" })))

      //Look through existing datasets for problem tables (tables that either don't exist or have outdated schema)
      const tablesByDataset = existingDatasetIds.map((datasetId) => {
        let tables = this.datasetTableIds.find((dt) => dt.datasetId === datasetId)?.tables ?? []
        if (this.selectedTableNames.length) {
          tables = this.selectedTableNames.map((name) => ({ name }))
        }
        return { datasetId, tables }
      })

      this.lookForProblemsTotalCount += tablesByDataset.reduce((total, entry) => total + entry.tables.length, 0)

      for (const { datasetId, tables } of tablesByDataset) {
        console.log(tables)
        for (const table of tables) {
          const tableId = table.name
          if (!(await getDatasetTableExists(datasetId, tableId)))
            this.problemItems.push({ type: "non-existing-table", datasetId, tableId, buttonState: "ready" })
          else if (!(await isDatasetTableSchemaUpdated(datasetId, tableId)))
            this.problemItems.push({ type: "outdated-table-schema", datasetId, tableId, buttonState: "ready" })
          this.lookForProblemsCheckedCount++
        }
      }

      this.lookForProblemsButtonState = "success"
      this.fixProblemsButtonState = "ready"
    } catch (err) {
      console.error(err)
      this.lookForProblemsButtonState = "error"
    }
  }

  async fixProblems() {
    try {
      this.fixProblemsButtonState = "busy"
      for (const problemItem of this.problemItems) {
        if (problemItem.type === "non-existing-dataset") await this.createDataset(problemItem)
        if (problemItem.type === "non-existing-table") await this.createTable(problemItem)
        if (problemItem.type === "outdated-table-schema") await this.updateSchema(problemItem)
      }
      this.fixProblemsButtonState = "success"
    } catch (err) {
      console.error(err)
      this.fixProblemsButtonState = "error"
    }
  }

  async createDataset(item: { datasetId: string; buttonState: ButtonState }) {
    throw Error("TODO: fix first, type 'abattoir' or 'feedlot' needs to be used")
    try {
      item.buttonState = "busy"
      let gql = `mutation createDatasetTables($datasetId: String!) {
        createDatasetTables(datasetId: $datasetId) {
          dataset
          tables {
            name
          }
        }
      }`
      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { datasetId: item.datasetId },
      })
      console.log("createDataset")
      console.dir(json)
      item.buttonState = "success"
    } catch (err) {
      console.error(err)
      item.buttonState = "error"
      throw err
    }
  }

  async createTable(item: { datasetId: string; tableId: string; buttonState: ButtonState }) {
    try {
      item.buttonState = "busy"
      let gql = `mutation createDatasetTable($datasetId: String!, $tableId: String!) {
        createDatasetTable(datasetId: $datasetId, tableId: $tableId)
      }`
      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { datasetId: item.datasetId, tableId: item.tableId },
      })
      console.log("createTable")
      console.dir(json)

      item.buttonState = "success"
    } catch (err) {
      console.error(err)
      item.buttonState = "error"
      throw err
    }
  }

  async updateSchema(item: { datasetId: string; tableId: string; buttonState: ButtonState }) {
    try {
      item.buttonState = "busy"
      let gql = `mutation updateTableSchema($datasetId: String!, $tableId: String!) {
        updateTableSchema(datasetId: $datasetId, tableId: $tableId)
      }`
      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { datasetId: item.datasetId, tableId: item.tableId },
      })
      console.log("updateSchema")
      console.dir(json)
      item.buttonState = "success"
    } catch (err) {
      console.error(err)
      item.buttonState = "error"
      throw err
    }
  }
}
